// extracted by mini-css-extract-plugin
module.exports = {"container":"create-campaign-upload-container__1uYLT","error":"create-campaign-upload-error__2BL6_"};